<template>
  <div>
    <!-- Featured -->
    <ProductCarousel
        v-if="featuredProducts.length"
      title="Featured Products"
      :products="featuredProducts"
    />

    <!-- New Arrivals -->
    <ProductCarousel
        v-if="newArrivalProducts.length"
      title="New Arrivals"
      :products="newArrivalProducts"
    />

    <!-- Discount -->
    <ProductCarousel
        v-if="discountProducts.length"
      title="Discount Products"
      :products="discountProducts"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import ProductCarousel from "@/components/feature/products/ProductCarousel.vue";
import { productService } from "~/services/product.service";

const featuredProducts = ref([]);
const newArrivalProducts = ref([]);
const discountProducts = ref([]);

const mapProducts = (data) =>
  data.map((product) => ({
    id: product.id,
    title: product.name,
    attachment: product.images?.[0]?.src || "",
    price: product.price,
    regularPrice: product.regular_price,
    description: product.short_description || product.description,
    discount: product.on_sale
      ? Math.round(
          ((product.regular_price - product.price) / product.regular_price) * 100
        )
      : 0,
  }));

onMounted(async () => {
  try {
    const [featuredRes, newArrivalRes, discountRes] = await Promise.all([
      productService.getFeaturedProducts(),
      productService.getNewArrivalProducts(),
      productService.getDiscountedProducts(),
    ]);

    featuredProducts.value = mapProducts(featuredRes.data);
    newArrivalProducts.value = mapProducts(newArrivalRes.data);
    discountProducts.value = mapProducts(discountRes.data);
  } catch (err) {
    console.error("Error fetching products:", err);
  }
});
</script>
